import React, { useState, useRef, useEffect } from "react";
import { Picker, Emoji } from "emoji-mart";
import PropTypes from "prop-types";

import "emoji-mart/css/emoji-mart.css";

const EmojiInput = props => {
  const emojiContainerRef = useRef(null);
  const [displayPicker, setDisplayPicker] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        emojiContainerRef.current &&
        !emojiContainerRef.current.contains(event.target)
      ) {
        setDisplayPicker(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [emojiContainerRef]);

  const togglePicket = () => {
    setDisplayPicker(!displayPicker);
  };

  const addEmoji = emoji => {
    //console.log(emoji);

    props.onEmojiSelected(emoji.native);
    togglePicket();
  };

  return (
    <div style={{ position: "relative" }} ref={emojiContainerRef}>
      <Emoji
        emoji={{ id: "slightly_smiling_face" }}
        size={30}
        onClick={togglePicket}
      />
      {displayPicker === true && (
        <Picker
          set="apple"
          onSelect={addEmoji}
          native={true}
          emoji="point_up"
          exclude={["flags", "symbols"]}
          style={{ position: "absolute", bottom: "20px", right: "20px" }}
        />
      )}
    </div>
  );
};

export default EmojiInput;

EmojiInput.defaultProps = {
  onEmojiSelected: () => {}
};

EmojiInput.prototype = {
  onEmojiSelected: PropTypes.func
};
